import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const useSendToHome = (isDeliveryOverride) => {
  const {deliveryLandingPage} = useSelector(state => state.session.features);
  const { isDelivery } = useSelector(state => state.basket);
  const navigate = useNavigate();
  const shouldNavigateToDelivery = isDeliveryOverride !== undefined ? isDeliveryOverride : isDelivery;
  if (!deliveryLandingPage && shouldNavigateToDelivery) {
    return () => {
      window.location.href = 'https://pizzaexpress.com/delivery';
    };
  } else {
      return () => {
          navigate(shouldNavigateToDelivery ? '/delivery': '/collection');
    };
  }
};